export const routeProps = {
  path: '/overview',
  exact: true,
};

export default () => routeProps;
